import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/Financial.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { updateCompanyMemberDetails } from '../../redux/actions/table/my_company_members';
import FinancialForm from '../../forms/my_company_members/FinancialForm';
import classNames from 'classnames';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
}))
@subscribe(Localization, 'localization')
class Financial extends Component {
  @autobind
  _handleSubmit(formData) {
    const {
      flyout: { details, compensation },
    } = this.props.table;

    formData = {
      ...formData,

      user_id: details?.id,
      firstname: details?.firstname,
      lastname: details?.lastname,
      // start_date: compensation?.start_date || null,
      // end_date: compensation?.end_date || null,
    };

    return validateForm(
      updateCompanyMemberDetails(formData).then(() => {
        this.props.readAction();
        setNotification(__('my-company-members.properties.saved'));
      })
    );
  }
  render() {
    const { data, collapsed, localization } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <FinancialForm
          onSubmit={this._handleSubmit}
          data={data}
          localization={localization}
          initialValues={{
            start_date: data.compensation?.start_date,
            end_date: data.compensation?.end_date,
            paycheck_currency_id: data?.compensation?.paycheck_currency_id,
            brutto_2: data.compensation?.brutto_2,
            hourly_rate: data.compensation?.hourly_rate,
            brutto_1: data.compensation?.brutto_1,
            chargeout_rate: data.compensation?.chargeout_rate,
            netto: data.compensation?.netto,
            rate_currency_id: data?.compensation?.rate_currency_id,
            user_id: data.details?.id,
            paycheck_changed_fields:
              data?.compensation?.paycheck_changed_fields,
            rate_changed_fields: data?.compensation?.rate_changed_fields,
            compensation_future: data?.compensation?.compensation_future,
            rate_future: data?.compensation?.rate_future,
          }}
        />
      </div>
    );
  }
}

export default Financial;
